import React from 'react';
import { graphql } from 'react-apollo';
import ARTIST_VISITS_QUERY from '../../../../graphql/ArtistVisits';
import VisitsStats from '../../../../components/VisitsStats';

const Visits = ({ stats }) => (
  <VisitsStats
    {...stats}
  />
);

const withArtistVisits = graphql(ARTIST_VISITS_QUERY, {
  props: ({ data }) => ({
    stats: data.getArtistVisits,
  }),
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
});

export default withArtistVisits(Visits);



// WEBPACK FOOTER //
// ./src/containers/Artist/Analytics/Artist/visits.js